import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';

import { BzObjType } from '@work4all/models/lib/Enums/BzObjType.enum';

import { PickerTargetButton } from '../../../../../../locked-inputs';
import { bzObjToEntityType } from '../../../../erp/components/simple-pdf-report/utils';

import { BzObjTypePicker, BzObjTypePickerProps } from './BzObjTypePicker';

export interface BzObjTypePickerFieldProps extends BzObjTypePickerProps {
  error?: string;
  disabled?: boolean;
  label?: string;
}

export const BzObjTypePickerField = React.forwardRef<
  HTMLDivElement,
  BzObjTypePickerFieldProps
>(function BzObjTypePickerField(props, ref) {
  const { error, label, ...pickerProps } = props;
  const { disabled, value } = pickerProps;

  const { t } = useTranslation();

  const popoverRef = useRef<EntityPickerPopover>(null);

  const name =
    value === BzObjType.UNKNOWN ? BzObjType.UNKNOWN : bzObjToEntityType[value];

  return (
    <EntityPickerPopover
      ref={popoverRef}
      picker={<BzObjTypePicker {...pickerProps} />}
    >
      <PickerTargetButton
        ref={ref}
        value={t(`COMMON.${name?.toUpperCase()}`)}
        label={label}
        error={error}
        disabled={disabled}
      />
    </EntityPickerPopover>
  );
});
